module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.14390/js/img/white_sprocket.svg"